export default __webpack_public_path__ + "static/media/about.8046c22d.jpg";